import React from "react";
import { FiCalendar, FiInfo, FiZap } from "react-icons/fi";
import {
  DEFAULT_INITIAL_MESSAGE_SEND_TIME,
  getInitialMessageSendTimes,
  normaliseInitialMessageSendTime,
} from "./automationConstants";

const InitialMessageSendTimeSelect = ({ value, error, onChange }) => {
  const options = getInitialMessageSendTimes();
  const normalisedValue = normaliseInitialMessageSendTime(value || DEFAULT_INITIAL_MESSAGE_SEND_TIME);
  const isTesting = normalisedValue === "+1m";
  const scheduledOptions = options.filter((option) => option.value !== "+1m");
  const scheduledValue = isTesting ? DEFAULT_INITIAL_MESSAGE_SEND_TIME : normalisedValue;

  return (
    <div className="form-group automation-send-timing-fieldset">
      <div className="automation-send-timing-options">
        <div className={`automation-send-timing-card testing ${isTesting ? "selected" : ""}`}>
          <input
            id="initial-message-timing-testing"
            type="radio"
            name="initial-message-timing-mode"
            checked={isTesting}
            onChange={() => onChange("+1m")}
          />
          <label className="automation-send-timing-mode-label" htmlFor="initial-message-timing-testing">
            <span className="automation-send-timing-icon"><FiZap /></span>
            <span className="automation-send-timing-copy">
              <strong>Testing</strong>
              <small>Send after 1 minute</small>
            </span>
          </label>
          <span className="automation-send-timing-badge">1 MINUTE</span>
        </div>

        <div className={`automation-send-timing-card live ${!isTesting ? "selected" : ""}`}>
          <input
            id="initial-message-timing-live"
            type="radio"
            name="initial-message-timing-mode"
            checked={!isTesting}
            onChange={() => onChange(scheduledValue)}
          />
          <label className="automation-send-timing-mode-label" htmlFor="initial-message-timing-live">
            <span className="automation-send-timing-icon"><FiCalendar /></span>
            <span className="automation-send-timing-copy">
              <strong>Live venue use</strong>
              <small>Send next calendar day</small>
            </span>
          </label>
          <span className="automation-send-time-select-wrap">
            <span className="sr-only" id="initial-message-send-time-label">Initial Message Send Time</span>
            <select
              id="initial-message-send-time"
              name="initial_message_send_time"
              aria-labelledby="initial-message-send-time-label"
              className={`form-control ${error ? "is-invalid" : ""}`}
              value={scheduledValue}
              onClick={(event) => event.stopPropagation()}
              onChange={(event) => onChange(event.target.value)}
            >
              {scheduledOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            <small>Choose the hour that works for your venue.</small>
          </span>
        </div>
      </div>
      {error ? <div className="invalid-feedback">{error}</div> : null}
      <div className="automation-send-timing-help">
        <FiInfo />
        <span>Use 1 minute for testing only. For live use, send on the next calendar day.</span>
        <span className="automation-field-tooltip">
          <button
            type="button"
            aria-label="About initial message send time"
            aria-describedby="initial-message-send-time-tooltip"
          >
            <FiInfo />
          </button>
          <span id="initial-message-send-time-tooltip" role="tooltip">
            Sets when the automation sends its first SMS. Clock times are scheduled for the next calendar day in the event&apos;s timezone.
            {" The 1-minute option sends shortly after the automation is triggered."}
          </span>
        </span>
      </div>
    </div>
  );
};

export default InitialMessageSendTimeSelect;
